import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import CustomSurveyList from 'components/businesses/tabs/questions/CustomSurveyList';
import CustomSurveyQuestionsDisplay from 'components/customSurvey/questions/customSurveyQuestions';
import CustomSurveyQuestionApi from 'apis/questions/CustomSurveyQuestion';
import SurveyApi from 'apis/Survey';
import Toaster from 'components/Toaster';

import 'assets/scss/questions.css';

class BusinessQuestions extends Component {
  constructor() {
    super();
    this.state = {
      questions: [],
      customSurveys: [],
      question_order: [],
    };
  }

  componentDidMount() {
    this.fetchCustomSurveys();
    this.fetchCustomSurveyDetails();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { customSurveyId } = this.getParams();

    if (location !== prevProps.location) {
      if (customSurveyId) {
        this.fetchCustomSurveyDetails();
        this.fetchSurveyQuestionDetails();
      }
    }
  }

  getParams = () => {
    const {
      match: { params },
    } = this.props;
    const { customSurveyId, id: businessId } = params;

    return { customSurveyId, businessId };
  };

  setOrderedQuestions = questions => {
    const questionOrder = questions.map(question => question.id);
    this.setState({ questions, question_order: questionOrder });
  };

  fetchCustomSurveys = () => {
    const { businessId } = this.getParams();
    SurveyApi.getAll(businessId)
      .then(({ data }) => {
        this.setState({ customSurveys: data });
      })
      .catch(() =>
        Toaster.getErrorToaster('exclamation-triangle', 'Something went wrong')
      );
  };

  fetchSurveyQuestionDetails = () => {
    const { customSurveyId } = this.getParams();

    if (customSurveyId) {
      CustomSurveyQuestionApi.getAll(customSurveyId)
        .then(({ data }) => {
          const questionOrder = data.map(question => question.id);

          this.setState({ questions: data, question_order: questionOrder });
        })
        .catch(() =>
          Toaster.getErrorToaster(
            'exclamation-triangle',
            'Something went wrong'
          )
        );
    }
  };

  saveQuestionOrder = () => {
    const { customSurveyId } = this.getParams();
    const { data, question_order: questionOrder } = this.state;
    SurveyApi.updateQuestionOrder(data, questionOrder, customSurveyId)
      .then(() => {
        this.fetchSurveyQuestionDetails();
        Toaster.getSuccessToaster(
          'check-circle',
          'Question arranged successfully'
        );
      })
      .catch(() => {
        Toaster.getErrorToaster('exclamation-triangle', 'Something went wrong');
      });
  };

  fetchCustomSurveyDetails = () => {
    const { customSurveyId } = this.getParams();

    if (customSurveyId) {
      SurveyApi.getDetails(customSurveyId)
        .then(({ data }) => {
          this.setState({ data, question_order: data.question_order });
        })
        .catch(() => {
          Toaster.getErrorToaster(
            'exclamation-triangle',
            'Something went wrong'
          );
        });
    }
  };

  render() {
    const { questions, customSurveys } = this.state;
    const { customSurveyId } = this.getParams();

    const initialDisplay = customSurveyId ? (
      <CustomSurveyQuestionsDisplay
        customSurveyId={customSurveyId}
        fetchDetails={this.fetchSurveyQuestionDetails}
        setOrderedQuestions={this.setOrderedQuestions}
        questions={questions}
        saveQuestionOrder={this.saveQuestionOrder}
      />
    ) : (
      <div className="question-welcome">
        Choose a survey to display questions
      </div>
    );

    return (
      <div className="questions-container">
        <Row>
          <Col md="3">
            <CustomSurveyList customSurveys={customSurveys} />
          </Col>
          <Col md="9">{initialDisplay}</Col>
        </Row>
      </div>
    );
  }
}

BusinessQuestions.propTypes = {
  location: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      customSurveyId: PropTypes.string,
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(BusinessQuestions);



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/questions/BusinessQuestions.js